"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var slate_react_1 = require("slate-react");
var slate_1 = require("slate");
var observe_rect_1 = __importDefault(require("@reach/observe-rect"));
var DropLocationStore_1 = require("Project/Stores/DropLocationStore/DropLocationStore");
var NO_SIBLING_BUFFER = 10;
var SIDE_BY_SIDE_COLUMN_SELECTOR = ".side-by-side__col";
var RelativePosition;
(function (RelativePosition) {
    RelativePosition[RelativePosition["Above"] = 0] = "Above";
    RelativePosition[RelativePosition["Below"] = 1] = "Below";
})(RelativePosition || (RelativePosition = {}));
var DropIndicatorLine = (function (_super) {
    __extends(DropIndicatorLine, _super);
    function DropIndicatorLine() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.rulerRef = react_1.default.createRef();
        _this.observingRuler = false;
        return _this;
    }
    DropIndicatorLine.prototype.componentDidMount = function () {
        var _this = this;
        this.rulerObserver = (0, observe_rect_1.default)(this.rulerRef.current, function (rect) {
            _this.contentLeft = rect.left;
            _this.contentWidth = rect.width;
        });
        this.observeRulerDisposer = (0, mobx_1.autorun)(function () {
            var _a;
            var _b = _this.props, dropLocationStore = _b.dropLocationStore, editor = _b.editor;
            var isSameEditor = ((_a = dropLocationStore.dropLocation) === null || _a === void 0 ? void 0 : _a.editorId) === editor.uniqueId;
            if (isSameEditor && !_this.observingRuler) {
                _this.rulerObserver.observe();
                _this.observingRuler = true;
            }
            else if (!isSameEditor && _this.observingRuler) {
                _this.rulerObserver.unobserve();
                _this.observingRuler = false;
            }
        });
        this.observeLineAnchorDisposer = (0, mobx_1.reaction)(function () { return _this.lineAnchor; }, function (lineAnchor) {
            var lineAnchorObserver = _this.lineAnchorObserver;
            if (lineAnchorObserver) {
                lineAnchorObserver.unobserve();
                _this.lineAnchorObserver = undefined;
            }
            if (lineAnchor) {
                _this.lineAnchorObserver = (0, observe_rect_1.default)(lineAnchor.anchorElement, function (rect) {
                    _this.lineDimensions = _this.buildLineDimensions(lineAnchor, rect);
                });
                _this.lineAnchorObserver.observe();
            }
            else {
                _this.lineDimensions = undefined;
            }
        }, { fireImmediately: true });
    };
    DropIndicatorLine.prototype.componentWillUnmount = function () {
        if (this.observingRuler) {
            this.rulerObserver.unobserve();
        }
        this.observeRulerDisposer();
        if (this.lineAnchorObserver) {
            this.lineAnchorObserver.unobserve();
        }
        this.observeLineAnchorDisposer();
    };
    Object.defineProperty(DropIndicatorLine.prototype, "lineAnchor", {
        get: function () {
            var _a = this.props, editor = _a.editor, dropLocationStore = _a.dropLocationStore;
            var dropLocation = dropLocationStore.dropLocation;
            if (!dropLocation) {
                return;
            }
            if (dropLocation.type !== DropLocationStore_1.DropLocationType.BetweenBlocks) {
                return;
            }
            if (dropLocation.editorId !== editor.uniqueId) {
                return;
            }
            var path = dropLocationStore.dropLocation.path;
            var dropLocationExists = slate_1.Node.has(editor, path);
            if (dropLocationExists) {
                return {
                    anchorElement: slate_react_1.ReactEditor.toDOMNode(editor, slate_1.Editor.node(editor, path)[0]),
                    relativePosition: RelativePosition.Above,
                };
            }
            else {
                return {
                    anchorElement: slate_react_1.ReactEditor.toDOMNode(editor, slate_1.Editor.node(editor, slate_1.Path.previous(path))[0]),
                    relativePosition: RelativePosition.Below,
                };
            }
        },
        enumerable: false,
        configurable: true
    });
    DropIndicatorLine.prototype.sanitizeRect = function (element, originalRect) {
        var _a = originalRect !== null && originalRect !== void 0 ? originalRect : element.getBoundingClientRect(), top = _a.top, bottom = _a.bottom, left = _a.left, width = _a.width;
        var measurableElement = element.classList.contains("promptable") ? element.firstElementChild : element;
        var twoColColumn = element.closest(SIDE_BY_SIDE_COLUMN_SELECTOR);
        var isInside2Col = !!twoColColumn;
        var requiresPaddingRemoval = ["H1", "H2", "P"].includes(measurableElement.tagName);
        if (requiresPaddingRemoval) {
            var _b = window.getComputedStyle(measurableElement), topPaddingPx = _b.paddingTop, bottomPaddingPx = _b.paddingBottom;
            var topPadding = parseInt(topPaddingPx, 10);
            var bottomPadding = parseInt(bottomPaddingPx, 10);
            top += topPadding;
            bottom -= bottomPadding;
        }
        var isWiderThanContent = width > this.contentWidth;
        if (isWiderThanContent && !isInside2Col) {
            left = this.contentLeft;
            width = this.contentWidth;
        }
        if (isInside2Col) {
            var _c = window.getComputedStyle(twoColColumn), leftPaddingPx = _c.paddingLeft, rightPaddingPx = _c.paddingRight;
            var leftPadding = parseInt(leftPaddingPx, 10);
            var rightPadding = parseInt(rightPaddingPx, 10);
            var _d = twoColColumn.getBoundingClientRect(), columnLeft = _d.left, columnWidth = _d.width;
            left = columnLeft + leftPadding;
            width = columnWidth - leftPadding - rightPadding;
        }
        return { top: top, bottom: bottom, left: left, width: width };
    };
    DropIndicatorLine.prototype.buildLineDimensions = function (lineAnchor, originalAnchorRect) {
        var anchorElement = lineAnchor.anchorElement, relativePosition = lineAnchor.relativePosition;
        var _a = this.sanitizeRect(lineAnchor.anchorElement, originalAnchorRect), left = _a.left, width = _a.width, anchorTop = _a.top, anchorBottom = _a.bottom;
        if (relativePosition === RelativePosition.Below) {
            return { left: left, width: width, top: anchorBottom + NO_SIBLING_BUFFER };
        }
        var previousElement = anchorElement.previousElementSibling;
        if (!previousElement) {
            return { left: left, width: width, top: anchorTop - NO_SIBLING_BUFFER };
        }
        var previousElementRect = this.sanitizeRect(previousElement);
        return { left: left, width: width, top: anchorTop + (previousElementRect.bottom - anchorTop) / 2 };
    };
    DropIndicatorLine.prototype.render = function () {
        var lineDimensions = this.lineDimensions;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { ref: this.rulerRef }),
            lineDimensions && react_1.default.createElement("div", { className: "drop-indicator-line", style: __assign({}, lineDimensions) })));
    };
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof LineDimensions !== "undefined" && LineDimensions) === "function" ? _a : Object)
    ], DropIndicatorLine.prototype, "lineDimensions", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], DropIndicatorLine.prototype, "lineAnchor", null);
    DropIndicatorLine = __decorate([
        mobx_react_1.observer
    ], DropIndicatorLine);
    return DropIndicatorLine;
}(react_1.default.Component));
exports.default = DropIndicatorLine;
